import { Component, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-hotel-description-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './hotel-description-dialog.component.html',
  styleUrls: ['./hotel-description-dialog.component.scss'],
})
export class HotelDescriptionDialogComponent {
  descriptionHtml = '';

  constructor(
    private dialogRef: MatDialogRef<HotelDescriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      description: string;
    },
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.setDescriptionHtml(this.data?.description);
  }

  setDescriptionHtml(desc?: string | null) {
    const raw = (desc ?? '').toString();
    this.descriptionHtml = isPlatformBrowser(this.platformId)
      ? this.cleanHotelDescriptionHtml(raw)
      : raw;
  }

  private cleanHotelDescriptionHtml(text: string): string {
    let value = (text || '').toString();

    for (let i = 0; i < 5; i++) {
      const decoded = this.decodeOnce(value);
      if (decoded === value) break;
      value = decoded;
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = value;

    value = wrapper.innerHTML;

    value = value
      .replace(/&nbsp;|&#160;/gi, ' ')
      .replace(/<p>\s*(<br\s*\/?>|&nbsp;|&#160;|\s)*<\/p>/gi, '')
      .replace(/<span>\s*<\/span>/gi, '')
      .replace(/<span>([^<]*)<\/span>/gi, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();

    return value;
  }

  private decodeOnce(text: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  close() {
    this.dialogRef.close();
  }
}